import type { BaseRowData, LegacyDataProviderRowData } from '@adv-frontend/data-provider';
import { useReactTable as useOriginReactTable } from '@tanstack/react-table';
import type { TableOptions } from '../types/tanstack-table-types';

import type { GridColumnDefinition, GridTable } from '../types';

/**
 * Тип для опций таблицы грида.
 *
 * @typeParam RowData Данные таблицы.
 */
export type GridTableOptions<RowData extends BaseRowData> = Omit<
    TableOptions<LegacyDataProviderRowData>,
    'data' | 'columns' | 'defaultColumn'
> & {
    data: LegacyDataProviderRowData[];
    columns: GridColumnDefinition<RowData, string>[];
    defaultColumn?: Partial<GridColumnDefinition<RowData, string>>;
};

/**
 * Возвращает типизированный хук `useReactTable` для использования с `dataProvider` в гридах.
 *
 * @typeParam RowData Данные таблицы.
 * @param options Опции таблицы.
 * @returns Хук `useReactTable`.
 */
export function useReactTable<RowData extends BaseRowData>(options: GridTableOptions<RowData>) {
    // Ограничиваем возможности react-table, поэтому приходится кастить тип.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions,react-hooks/incompatible-library -- см. выше
    return useOriginReactTable(options as TableOptions<LegacyDataProviderRowData>) as unknown as GridTable<RowData>;
}
